<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jennie Dodd was raised in the picturesque market town of Shrewsbury, famous for its medieval castle, steep narrow streets, little alleyways, and timber framed buildings. Situated on the River Severn the town nestles in amongst the ancient Shropshire hills of the Stiperstones, the Long Mynd, Wenlock Edge and The Wrekin. Educated at the Wakeman Grammar School, Jennie developed a keen interest in art, history, and a love of English literature. Her novel reflects her appreciation of the works of J B Priestley and his socialist beliefs—that all men are born equal. <em>The Satin Moth</em>, as a result, explores themes connected to Britain’s bloody colonial past.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ea445d3a